<template>
  <ul>
    <li v-for="(v, idx) in list.slice(0, limit)" :key="idx">
      {{ v }}
    </li>
    <li v-if="list.length > limit">...</li>
  </ul>
</template>
<script>
export default {
  props: {
    list: Array,
    limit: {
      type: Number,
      default: 5
    }
  }
};
</script>
